import { useEffect } from "react";

export default function UscitaLezionePage() {
  useEffect(() => {
    window.close();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F2B48] p-6" data-testid="uscita-lezione-page">
      <div className="text-center text-white max-w-md">
        <img src="/isteform-logo-white.svg" alt="Centro Studi ISTEFORM" className="h-14 w-auto mx-auto mb-6"/>
        <div className="h-1 w-24 mx-auto rounded-full bg-gradient-to-r from-[#F7941E] via-[#00A896] to-[#1F4E79] mb-6"/>
        <h1 className="text-2xl font-extrabold mb-2">Lezione terminata</h1>
        <p className="text-slate-300 text-sm">La sessione online è conclusa. Puoi chiudere questa scheda del browser.</p>
      </div>
    </div>
  );
}
